package org.example.site_web.components.widgets.form

import com.varabyte.kobweb.compose.css.Background
import com.varabyte.kobweb.compose.css.Resize
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.alignSelf
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.leftRight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.outline
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.resize
import com.varabyte.kobweb.compose.ui.modifiers.topBottom
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.selectors.disabled
import com.varabyte.kobweb.silk.style.selectors.focus
import com.varabyte.kobweb.silk.style.selectors.invalid
import com.varabyte.kobweb.silk.theme.colors.palette.color
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette
import org.example.site_web.toSitePalette
import org.jetbrains.compose.web.css.AlignSelf
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

val Label2Style = CssStyle{
    base{
        Modifier
            .margin{
                top(0.25.em)
                bottom(0.25.em)
            }
            .border(1.px, LineStyle.None)
            .alignSelf(AlignSelf.Stretch)
    }
}

val Description2Style = CssStyle.base{
    Modifier
        .padding(leftRight = 0.0.em,bottom=0.2.em)
        .zIndex(1)
        .background(Background.None)
        .fontSize(0.8.em)
}

val InputEditShowOnlyStyle = CssStyle{
    base {
        Modifier
            .width(100.percent)
            .fontSize(1.em)
            .background(Background.None)
            .padding{
                topBottom(0.2.em)
                leftRight(0.61.em)
            }
            .border {
                style(LineStyle.Solid) }
            .outline{
                style(LineStyle.None) }
    }

    disabled{
        Modifier
            .color(colorMode.toPalette().color)
    }
}
val InputEditStyle = CssStyle{
    base {
        Modifier
            .width(100.percent)
            .fontSize(1.em)
            .background(if(colorMode.isDark) Colors.Black  else Colors.White)
            .padding{
                topBottom(0.2.em)
                leftRight(0.61.em)
            }
            .border {
                style(LineStyle.Solid)
                color(if(colorMode.isDark) Colors.Black  else Colors.White)
            }
            .outline {
                style(LineStyle.Solid)
                color(colorMode.toSitePalette().brand.primary)
                width(2.px)
            }
    }
    focus{
        Modifier
            .outline{
            style(LineStyle.Solid)
            color(colorMode.toSitePalette().brand.primary)
            width(4.px)}
    }
    invalid{
        Modifier
            .background(if(colorMode.isDark) Colors.DarkRed  else Colors.Red)
    }
}

val TextAreaShowOnlyFieldStyle = CssStyle{
    base {
        Modifier
            .width(100.percent)
            .fontSize(1.em)
            .fontFamily("Segoe UI","sans-serif")
            .background(Background.None)
            .padding{
                topBottom(0.2.em)
                leftRight(0.61.em)
            }
            .border {
                style(LineStyle.Solid) }
            .outline{
                style(LineStyle.None) }
            .resize(Resize.None)
    }

    disabled{
        Modifier
            .color(colorMode.toPalette().color)
    }
}
val TextAreaEditStyle = CssStyle{
    base {
        Modifier
            .width(100.percent)
            .fontSize(1.em)
            .fontFamily("Segoe UI","sans-serif")
            .background(if(colorMode.isDark) Colors.Black  else Colors.White)
            .padding{
                topBottom(0.2.em)
                leftRight(0.61.em)
            }
            .border {
                style(LineStyle.Solid)
                color(if(colorMode.isDark) Colors.Black  else Colors.White)
            }
            .outline {
                style(LineStyle.Solid)
                color(colorMode.toSitePalette().brand.primary)
                width(2.px)
            }
            .resize(Resize.None)
    }
    focus{
        Modifier
            .outline{
                style(LineStyle.Solid)
                color(colorMode.toSitePalette().brand.primary)
                width(4.px)}
    }
    invalid{
        Modifier
            .background(if(colorMode.isDark) Colors.DarkRed  else Colors.Red)
    }
}